// Feature card: a roomy surface card with an icon tile, a title and text on the left, a tonal action button on the right (on phones: full width at the bottom) and, below, any
// content (a row of pictures, cards...). It is what the "Portfolio preview" block shows, as a plain component you can fill with anything.
// Props: icon, tone (IconTile tone, default 'primary'), title, text, action { label, href | onClick }, children, aria-label, sx
// It is a size container: content inside can lay itself out by the card's own width (@container), so it also fits a grid cell.
(function () {
  const { Box, Typography } = MaterialUI;

  function FeatureCard({ icon, tone = 'primary', title, text, action, children, sx, ...rest }) {
    const { SurfaceCard, IconTile, Button, GoogleIcon } = window.Components;
    return (
      <SurfaceCard component="section" aria-label={rest['aria-label'] || title} sx={[{ my: 3, p: { xs: 2.5, md: 4 }, containerType: 'inline-size' }, ...(Array.isArray(sx) ? sx : [sx])]}>
        <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'flex-end', justifyContent: 'space-between', gap: 2, mb: children ? 3 : { xs: action && action.label ? 2.5 : 0, md: 0 } }}>
          <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start', flex: '1 1 320px', minWidth: 0 }}>
            {icon && <IconTile icon={icon} tone={tone} size="lg" shape="large" />}
            <Box sx={{ minWidth: 0 }}>
              <Typography variant="h5" component="h3" sx={{ m: 0 }}>{title}</Typography>
              {text && <Typography variant="body1" sx={{ color: 'text.secondary', mt: 1, maxWidth: 680, whiteSpace: 'pre-line' }}>{text}</Typography>}
            </Box>
          </Box>
          {/* Wide screens: beside the title. Phones: the same button, full width at the bottom of the card (below) */}
          {action && action.label && (
            <Button variant="tonal" href={action.href} onClick={action.onClick} trailingIcon={<GoogleIcon name="arrow_forward" size={18} />} sx={{ display: { xs: 'none', md: 'inline-flex' } }}>{action.label}</Button>
          )}
        </Box>
        {children}
        {action && action.label && (
          <Button variant="tonal" href={action.href} onClick={action.onClick} trailingIcon={<GoogleIcon name="arrow_forward" size={18} />} sx={{ display: { xs: 'flex', md: 'none' }, width: '100%', mt: children ? 3 : 0 }}>{action.label}</Button>
        )}
      </SurfaceCard>
    );
  }

  window.Components = window.Components || {};
  window.Components.FeatureCard = FeatureCard;
})();
